import { memo } from "react"

const IconEdit = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33333 10.0716C9.33333 10.6573 8.85848 11.1322 8.27273 11.1322H3.00883C2.99367 11.1322 2.97792 11.138 2.96275 11.138C2.9435 11.138 2.92425 11.1327 2.90442 11.1322H2.22727C1.64152 11.1322 1.16667 10.6573 1.16667 10.0716V4.0261C1.16667 3.44034 1.64152 2.96549 2.22727 2.96549H4.91913C5.07383 2.96549 5.22221 2.90404 5.3316 2.79464C5.69908 2.42716 5.43882 1.79883 4.91912 1.79883H1.16667C0.52325 1.79883 0 2.32149 0 2.96549V11.1322C0 11.7762 0.52325 12.2988 1.16667 12.2988H9.33333C9.64275 12.2988 9.9395 12.1759 10.1583 11.9571C10.3771 11.7383 10.5 11.4416 10.5 11.1322V7.48412C10.5 6.96442 9.87167 6.70416 9.50419 7.07164C9.39479 7.18104 9.33333 7.32941 9.33333 7.48412V10.0716Z"
        fill="#002C98"
      />
      <path
        d="M3.75398 6.1716L3.2623 8.29809C3.24534 8.37582 3.24592 8.45638 3.26401 8.53386C3.28209 8.61134 3.31721 8.68379 3.36681 8.74593C3.41642 8.80806 3.47924 8.85831 3.5507 8.89299C3.62216 8.92768 3.70045 8.94593 3.77985 8.94641C3.81685 8.95015 3.85413 8.95015 3.89113 8.94641L6.02601 8.45369L10.125 4.36149L7.83743 2.07422L3.75398 6.1716Z"
        fill="#002C98"
      />
      <path
        d="M11.3344 2.45753L9.73899 0.862159C9.6341 0.757802 9.49216 0.699219 9.3442 0.699219C9.19624 0.699219 9.0543 0.757802 8.94942 0.862159L8.0625 1.74908L10.4501 4.13672L11.3371 3.2498C11.389 3.19764 11.4301 3.13575 11.458 3.06768C11.486 2.99961 11.5002 2.92669 11.5 2.8531C11.4997 2.77952 11.485 2.7067 11.4566 2.63882C11.4281 2.57094 11.3866 2.50934 11.3344 2.45753Z"
        fill="#002C98"
      />
    </svg>
  )
}

export default memo(IconEdit)
